import React, { useEffect, useState } from 'react';
import { Box, useTheme } from '@mui/material';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import ProtectedRoute from './protectedRoute';
import * as token from '../../src/services/commonMethods';
import Loader from '../sharedComponent/loader';
import AppLayout from '../UI/Layouts/AppLayout';
import ScrollToTop from './ScrollToTop';

const UserActions = React.lazy(
  () => import('../authenticatedComponent/settings/userActions/userActions'),
);
const Profile = React.lazy(() => import('../authenticatedComponent/settings/profile/profile'));
const ChangePassword = React.lazy(
  () => import('../authenticatedComponent/settings/changePassword/changePassword'),
);

const Preferences = React.lazy(
  () => import('../authenticatedComponent/settings/preferences/preferences'),
);

const ConnectedApps = React.lazy(() => import('../Pages/ConnectedApps'));

const ConnectedAppDetailView = React.lazy(
  () => import('../Components/ConnectedApps/ConnectedAppDetailView'),
);

const MyReferral = React.lazy(() => import('../Pages/MyRefferal'));
const Dashboard = React.lazy(() => import('../Pages/Dashboard'));
const EventDetailView = React.lazy(() => import('../Pages/EventDetailView'));
const ParticipantDetailView = React.lazy(() => import('../Pages/ParticipantDetailView'));
const TeamDetailView = React.lazy(
  () => import('../Components/Teams/TeamReports/TeamsDetailView/TeamDetailView'),
);
const TeamStageDetailView = React.lazy(() => import('../Pages/TeamStageDetailView'));
const TeamReportParticipantView = React.lazy(
  () =>
    import('../Components/Teams/TeamReports/TeamReportParticipantView/TeamReportParticipantView'),
);
const TeamStageActivity = React.lazy(() => import('../Pages/TeamStageParticipantView'));
const EventListView = React.lazy(() => import('../Pages/EventListView'));
const BannerAndCertificate = React.lazy(() => import('../Pages/BannerAndCertificate'));

const PastEventDetailView = React.lazy(() => import('../Pages/PastEventDetailView'));

const LeaderBoardViewAllDetailView = React.lazy(
  () => import('../Pages/LeaderBoardViewAllDetailView'),
);
const LeaderBoardViewAll = React.lazy(() => import('../Pages/leaderBoardViewAll'));
const PastEventPublic = React.lazy(() => import('../Pages/PastEventPublic'));
const Coupons = React.lazy(() => import('../Pages/Coupons'));
const Login = React.lazy(() => import('../Pages/Login'));
const PageNotFound = React.lazy(() => import('../publicComponents/pageNotFound'));

const EventTarget = React.lazy(() => import('../Pages/EventTarget'));

const AppNavigation = (props) => {
  const theme = useTheme();
  useEffect(() => {
    if (token?.getHeadervisible()) {
      props.checkHeaderShowOrHide(true);
    } else {
      props.checkHeaderShowOrHide(false);
    }
  }, [props]);

  const [isMaintenanceActive, setIsMaintenanceActive] = useState(false);

  useEffect(() => {
    const isMaintenanceActive = window.MaintenanceWatcher.getMaintenanceStatus();
    console.log('isMaintenanceActive', isMaintenanceActive);
    setIsMaintenanceActive(isMaintenanceActive);
  }, []);

  return (
    <AppLayout
      appHeader={
        <Box sx={{ backgroundColor: theme.palette.background.default }}>
          <app-header-nav
            data-currentApp={'USER'}
            data-userRoles={['ROLE_RUNNER']}
          ></app-header-nav>
        </Box>
      }
      appContent={
        // <Box sx={{ minHeight: 'calc(100vh - 60px)' }}>
        // {
        isMaintenanceActive ? (
          'Loading...'
        ) : (
          <>
            <Router>
              <ScrollToTop />
              <Routes>
                {/* Authentication Screens */}
                <Route
                  path="/"
                  element={
                    <React.Suspense fallback={<Loader />}>
                      <Login />
                    </React.Suspense>
                  }
                ></Route>

                {/* user settings Routing */}
                <Route
                  exact
                  path="/user"
                  element={
                    <React.Suspense fallback={<Loader />}>
                      <ProtectedRoute Component={UserActions}></ProtectedRoute>
                    </React.Suspense>
                  }
                ></Route>
                <Route
                  exact
                  path="/user/profile"
                  element={
                    <React.Suspense fallback={<Loader />}>
                      <ProtectedRoute Component={Profile}></ProtectedRoute>
                    </React.Suspense>
                  }
                ></Route>
                <Route
                  exact
                  path="/user/changePassword"
                  element={
                    <React.Suspense fallback={<Loader />}>
                      <ProtectedRoute Component={ChangePassword}></ProtectedRoute>
                    </React.Suspense>
                  }
                ></Route>
                <Route
                  exact
                  path="/user/coupons"
                  element={
                    <React.Suspense fallback={<Loader />}>
                      <ProtectedRoute Component={Coupons}></ProtectedRoute>
                    </React.Suspense>
                  }
                ></Route>
                <Route
                  exact
                  path="/user/preference"
                  element={
                    <React.Suspense fallback={<Loader />}>
                      <ProtectedRoute Component={Preferences}></ProtectedRoute>
                    </React.Suspense>
                  }
                ></Route>
                <Route path="/user/connected-apps">
                  <Route
                    index
                    element={
                      <React.Suspense fallback={<Loader />}>
                        <ProtectedRoute Component={ConnectedApps}></ProtectedRoute>
                      </React.Suspense>
                    }
                  ></Route>
                  <Route path="/user/connected-apps/details">
                    <Route
                      index
                      element={
                        <React.Suspense fallback={<Loader />}>
                          <ProtectedRoute Component={ConnectedAppDetailView}></ProtectedRoute>
                        </React.Suspense>
                      }
                    ></Route>
                    <Route
                      path=":partner"
                      element={
                        <React.Suspense fallback={<Loader />}>
                          <ProtectedRoute Component={ConnectedAppDetailView}></ProtectedRoute>
                        </React.Suspense>
                      }
                    ></Route>
                  </Route>
                </Route>
                <Route
                  exact
                  path="/user/download"
                  element={
                    <React.Suspense fallback={<Loader />}>
                      <ProtectedRoute Component={BannerAndCertificate}></ProtectedRoute>
                    </React.Suspense>
                  }
                ></Route>
                <Route
                  exact
                  path="/user/referral"
                  element={
                    <React.Suspense fallback={<Loader />}>
                      <ProtectedRoute Component={MyReferral}></ProtectedRoute>
                    </React.Suspense>
                  }
                ></Route>

                {/* Dashboard */}
                <Route path="/dashboard">
                  <Route
                    index
                    element={
                      <React.Suspense fallback={<Loader />}>
                        <ProtectedRoute Component={Dashboard}></ProtectedRoute>
                      </React.Suspense>
                    }
                  ></Route>
                  <Route path="/dashboard/my-event">
                    <Route
                      index
                      element={
                        <React.Suspense fallback={<Loader />}>
                          <ProtectedRoute Component={Dashboard}></ProtectedRoute>
                        </React.Suspense>
                      }
                    ></Route>
                    <Route path=":eventStatus">
                      <Route
                        index
                        element={
                          <React.Suspense fallback={<Loader />}>
                            <ProtectedRoute Component={EventListView}></ProtectedRoute>
                          </React.Suspense>
                        }
                      ></Route>
                    </Route>
                  </Route>
                  <Route path="/dashboard/past-event">
                    <Route
                      index
                      element={
                        <React.Suspense fallback={<Loader />}>
                          <ProtectedRoute Component={Dashboard}></ProtectedRoute>
                        </React.Suspense>
                      }
                    ></Route>
                  </Route>
                  <Route path="/dashboard/explore-event">
                    <Route
                      index
                      element={
                        <React.Suspense fallback={<Loader />}>
                          <ProtectedRoute Component={Dashboard}></ProtectedRoute>
                        </React.Suspense>
                      }
                    ></Route>
                    <Route path=":eventStatus">
                      <Route
                        index
                        element={
                          <React.Suspense fallback={<Loader />}>
                            <ProtectedRoute Component={EventListView}></ProtectedRoute>
                          </React.Suspense>
                        }
                      ></Route>
                    </Route>
                  </Route>

                  <Route path=":eventName">
                    <Route
                      index
                      element={
                        <React.Suspense fallback={<Loader />}>
                          <ProtectedRoute Component={EventDetailView}></ProtectedRoute>
                        </React.Suspense>
                      }
                    ></Route>
                    <Route path=":eventId">
                      <Route
                        index
                        element={
                          <React.Suspense fallback={<Loader />}>
                            <ProtectedRoute Component={EventDetailView}></ProtectedRoute>
                          </React.Suspense>
                        }
                      ></Route>
                      <Route path=":selectedCategory">
                        <Route
                          index
                          element={
                            <React.Suspense fallback={<Loader />}>
                              <ProtectedRoute Component={EventDetailView}></ProtectedRoute>
                            </React.Suspense>
                          }
                        ></Route>
                        <Route path=":selectedSubCategory">
                          <Route
                            index
                            element={
                              <React.Suspense fallback={<Loader />}>
                                <ProtectedRoute Component={EventDetailView}></ProtectedRoute>
                              </React.Suspense>
                            }
                          ></Route>
                          <Route
                            path=":runnerId"
                            element={
                              <React.Suspense fallback={<Loader />}>
                                <ProtectedRoute Component={ParticipantDetailView}></ProtectedRoute>
                              </React.Suspense>
                            }
                          ></Route>

                          <Route path=":teamId/team-details">
                            <Route
                              index
                              element={
                                <React.Suspense fallback={<Loader />}>
                                  <ProtectedRoute Component={TeamDetailView}></ProtectedRoute>
                                </React.Suspense>
                              }
                            ></Route>
                            <Route
                              path=":runnerId"
                              element={
                                <React.Suspense fallback={<Loader />}>
                                  <ProtectedRoute
                                    Component={TeamReportParticipantView}
                                  ></ProtectedRoute>
                                </React.Suspense>
                              }
                            ></Route>
                          </Route>
                          <Route path=":teamId/team-details/team-stage">
                            <Route
                              index
                              element={
                                <React.Suspense fallback={<Loader />}>
                                  <ProtectedRoute Component={TeamStageDetailView}></ProtectedRoute>
                                </React.Suspense>
                              }
                            ></Route>
                            <Route
                              path=":runnerId"
                              element={
                                <React.Suspense fallback={<Loader />}>
                                  <ProtectedRoute Component={TeamStageActivity}></ProtectedRoute>
                                </React.Suspense>
                              }
                            ></Route>
                          </Route>
                        </Route>
                      </Route>
                    </Route>
                  </Route>
                </Route>

                <Route path="/past">
                  <Route
                    index
                    element={
                      <React.Suspense fallback={<Loader />}>
                        <PastEventDetailView />
                      </React.Suspense>
                    }
                  ></Route>
                  <Route path=":eventName">
                    <Route
                      index
                      element={
                        <React.Suspense fallback={<Loader />}>
                          <PastEventDetailView />
                        </React.Suspense>
                      }
                    ></Route>
                    <Route path=":eventId">
                      <Route
                        index
                        element={
                          <React.Suspense fallback={<Loader />}>
                            <PastEventDetailView />
                          </React.Suspense>
                        }
                      ></Route>
                      <Route path=":selectedCategory">
                        <Route
                          index
                          element={
                            <React.Suspense fallback={<Loader />}>
                              <PastEventDetailView />
                            </React.Suspense>
                          }
                        ></Route>
                        <Route path=":selectedSubCategory">
                          <Route
                            index
                            element={
                              <React.Suspense fallback={<Loader />}>
                                <PastEventDetailView />
                              </React.Suspense>
                            }
                          ></Route>
                          <Route
                            path=":runnerId"
                            element={
                              <React.Suspense fallback={<Loader />}>
                                <ParticipantDetailView />
                              </React.Suspense>
                            }
                          ></Route>
                          <Route path=":teamId/team-details">
                            <Route
                              index
                              element={
                                <React.Suspense fallback={<Loader />}>
                                  <TeamDetailView />
                                </React.Suspense>
                              }
                            ></Route>
                            <Route
                              path=":runnerId"
                              element={
                                <React.Suspense fallback={<Loader />}>
                                  <TeamReportParticipantView />
                                </React.Suspense>
                              }
                            ></Route>
                          </Route>
                          <Route path=":teamId/team-details/team-stage">
                            <Route
                              index
                              element={
                                <React.Suspense fallback={<Loader />}>
                                  <TeamStageDetailView />
                                </React.Suspense>
                              }
                            ></Route>
                            <Route
                              path=":runnerId"
                              element={
                                <React.Suspense fallback={<Loader />}>
                                  <TeamStageActivity />
                                </React.Suspense>
                              }
                            ></Route>
                          </Route>
                        </Route>
                      </Route>
                    </Route>
                  </Route>
                </Route>

                <Route path="/view-all/:eventId">
                  <Route
                    index
                    element={
                      <React.Suspense fallback={<Loader />}>
                        <LeaderBoardViewAll />
                      </React.Suspense>
                    }
                  ></Route>
                  <Route path=":entity">
                    <Route
                      index
                      element={
                        <React.Suspense fallback={<Loader />}>
                          <LeaderBoardViewAllDetailView />
                        </React.Suspense>
                      }
                    ></Route>
                    <Route
                      path=":runnerId"
                      element={
                        <React.Suspense fallback={<Loader />}>
                          <LeaderBoardViewAllDetailView />
                        </React.Suspense>
                      }
                    ></Route>
                  </Route>
                  <Route path="gender/:runnerId">
                    <Route
                      index
                      element={
                        <React.Suspense fallback={<Loader />}>
                          <ParticipantDetailView />
                        </React.Suspense>
                      }
                    ></Route>
                  </Route>
                </Route>

                <Route path="event-target">
                  <Route
                    index
                    element={
                      <React.Suspense fallback={<Loader />}>
                        <EventTarget />
                      </React.Suspense>
                    }
                  ></Route>
                  <Route path=":eventId">
                    <Route
                      index
                      element={
                        <React.Suspense fallback={<Loader />}>
                          <EventTarget />
                        </React.Suspense>
                      }
                    ></Route>
                  </Route>
                </Route>

                <Route
                  path="/results"
                  element={
                    <React.Suspense fallback={<Loader />}>
                      <PastEventPublic />
                    </React.Suspense>
                  }
                ></Route>

                {/* Not found page */}
                <Route
                  path="*"
                  element={
                    <React.Suspense fallback={<Loader />}>
                      <PageNotFound />
                    </React.Suspense>
                  }
                ></Route>
              </Routes>
            </Router>
          </>
        )
        // }
        // </Box>
      }
      appFooter={
        <Box sx={{ backgroundColor: theme.palette.background.default }}>
          <app-footer />
        </Box>
      }
    />
  );
};

export default AppNavigation;
